import axios, {AxiosResponse} from 'axios'
import {ProfessionQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/jobs`

const getProfessionSelect = (query: string): Promise<ProfessionQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<ProfessionQueryResponse>) => d.data)
}

export {getProfessionSelect}
